module.exports = __webpack_public_path__ + "media/images/ws-icon-00848ab6.png";